(() => {
  const selector = '[data-gp-type],[data-gp-core]';
  let observer;
  let started = false;
  if (document.readyState === 'complete') window.__gpShopperDOMContentLoaded = true;
  else document.addEventListener('DOMContentLoaded', () => { window.__gpShopperDOMContentLoaded = true; }, { once: true });

  function loadVideoWidgets() {
    if (started || !document.querySelector(selector)) return false;
    started = true;
    observer?.disconnect();
    if (window.__gpShopperLoaded || document.querySelector('script[src*="gp-shopper.js"],script[src*="gp-shopper-original.js"],script[src*="player.vidvisor.io/core.js"]')) return true;
    const script = document.createElement('script');
    script.src = 'https://shopper.ghostretail.com/gp-shopper.js';
    script.async = true;
    document.head.appendChild(script);
    return true;
  }

  if (loadVideoWidgets()) return;
  observer = new MutationObserver(records => {
    const addedWidget = records.some(record => record.type === 'attributes'
      ? record.target.matches(selector)
      : Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector)))
    );
    if (addedWidget) loadVideoWidgets();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-gp-type', 'data-gp-core'] });
})();
